module.exports = __webpack_public_path__ + "img/ltktopshared-2x.c0f9c63.jpg";